import { NgModule } from '@angular/core';
import { SharedModule } from '../../modules/shared.module';
import { EguardWidgetComponent } from './widget.component';
import { EguardWidgetToggleDirective } from './widget-toggle.directive';

@NgModule({
    imports     : [
        SharedModule
    ],
    exports     : [
        EguardWidgetComponent,
        EguardWidgetToggleDirective
    ],
    declarations: [
        EguardWidgetComponent,
        EguardWidgetToggleDirective
    ]
})
export class EguardWidgetModule
{
}



// WEBPACK FOOTER //
// ./src/app/core/components/widget/widget.module.ts